export default {"src":"/_next/static/media/wix.7a6c02fb.svg","height":60,"width":154,"blurWidth":0,"blurHeight":0};